<template>
    <div class="goods-list">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="出售中" name="sell">
                    <span slot="label">出售中 <el-tag size="mini">{{ goods_count.sell }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="仓库中" name="lower">
                    <span slot="label">仓库中 <el-tag size="mini">{{ goods_count.lower }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="回收站" name="recovery">
                    <span slot="label">回收站 <el-tag size="mini">{{ goods_count.recovery }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="库存紧张" name="stock">
                    <span slot="label">库存紧张 <el-tag size="mini">{{ goods_count.stock }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="草稿箱" name="draft">
                    <span slot="label">草稿箱 <el-tag size="mini">{{ goods_count.draft }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="待审核" name="audit">
                    <span slot="label">待审核 <el-tag size="mini">{{ goods_count.audit }}</el-tag></span>
                </el-tab-pane>
                <el-tab-pane label="未通过" name="no_audit">
                    <span slot="label">未通过 <el-tag size="mini">{{ goods_count.no_audit }}</el-tag></span>
                </el-tab-pane>
            </el-tabs>
            <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="商品分类">
                    <el-select v-model="searchForm.category_id" size="small" placeholder="所有分类">
                        <el-option label="全部" value="0"></el-option>
                        <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称"><el-input v-model="searchForm.goods_name" size="small" placeholder="请输入商品名称"></el-input></el-form-item>
                <el-form-item label="供货商">
                    <el-select size="small" v-model="searchForm.supplier_id" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, index) in supplierlist" :key="index" :label="item.supplier_name" :value="item.supplier_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!--添加产品-->
        <div v-if="merch.status == 0" class="common-level-rail"><el-button v-auth="'/goods/goods/add'" size="small" type="primary" icon="el-icon-plus" @click="addClick">添加产品</el-button></div>
        <div v-if="merch.status != 0" class="common-level-rail">
            <el-button v-auth="'/goods/goods/add'" size="small" type="primary" icon="el-icon-plus" disabled>添加产品</el-button>
            <span v-if="merch.status == 10" class="red pl16">正在退保证金</span>
            <span v-if="merch.status == 20" class="red pl16">未交纳保证金，请到移动端交纳</span>
        </div>
        <!--内容-->
        <div class="goods-content">
            <div class="table-wrap">
                <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                    <el-table-column prop="goods_name" label="产品" width="400px">
                        <template slot-scope="scope">
                            <div class="goods-info">
                                <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt=""/></div>
                                <div class="info">
                                    <div class="name">
                                        {{ scope.row.goods_name }}
                                        <a v-if="scope.row.source_url" :href="scope.row.source_url" target="_blank"><i class="el-icon-link"></i></a>
                                    </div>
                                    <div class="price">￥{{ scope.row.goods_price }}</div>
                                    <div v-if="scope.row.audit_status == 20" class="price">未通过原因：{{ scope.row.audit_remark }}</div>
                                    <div v-if="scope.row.audit_status == 30" class="price">强制下架：{{ scope.row.audit_remark }}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category_path" label="分类"></el-table-column>
                    <el-table-column prop="settlement_price" label="结算价"></el-table-column>
                    <el-table-column prop="sales_actual" label="实际销量"></el-table-column>
                    <el-table-column prop="goods_stock" label="库存"></el-table-column>
                    <el-table-column prop="view_times" label="点击数"></el-table-column>
                    <el-table-column prop="goods_status.text" label="商品属性">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_virtual == 0">实物商品</span>
                            <span v-if="scope.row.is_virtual == 1" class="green">虚拟商品</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="发布时间"></el-table-column>
                    <el-table-column prop="goods_sort" label="排序">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.goods_sort" size="mini" @change="changeSort($event,scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="80">
                        <template v-if="merch.status == 0" slot-scope="scope">
                            <div class="table-btn-column">
                                <el-button type="text" size="small" @click="previewClick(scope.row)">预览</el-button>
                                <el-button v-auth="'/goods/goods/edit'" type="text" size="small" @click="editClick(scope.row)">编辑商品</el-button>
                                <el-button v-auth="'/goods/goods/delete'" type="text" size="small" @click="delClick(scope.row)">删除商品</el-button>
                                <el-button v-if="activeName == 'sell'" v-auth="'/goods/goods/state'" type="text" size="small" @click="changeStatus(scope.row, 20)">立即下架</el-button>
                                <el-button v-if="activeName == 'lower'" v-auth="'/goods/goods/state'" type="text" size="small" @click="changeStatus(scope.row, 10)">立即上架</el-button>
                                <el-button v-if="activeName == 'recovery'" v-auth="'/goods/goods/state'" type="text" size="small" @click="changeStatus(scope.row, 20)">恢复</el-button>
                                <el-button v-auth="'/goods/goods/copy'" type="text" size="small" @click="copyClick(scope.row)">一键复制</el-button>

                                <el-button type="text" size="small" @click="editCoupon(scope.row)">关联优惠券</el-button>
                                <el-button type="text" size="small" @click="editRelation(scope.row)">关联商品</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination
                background
                :current-page="curPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="totalDataNumber"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <!--二维码弹窗-->
        <el-dialog title="商品预览" :visible.sync="qrcodeDialog" width="300px" center>
            <div class="qrcode-wrap">
                <div class="qrcode-img">
                    <img :src="qrCodeData" alt="QR Code" style="margin:0 auto;">
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import GoodsApi from "@/api/goods.js";
    // 引入二维码依赖
    import QRCode from "qrcode";

    export default {
        components: {},
        data() {
            return {
                /*切换菜单*/
                activeName: "sell",
                /*切换选中值*/
                activeIndex: "0",
                /*是否正在加载*/
                loading: true,
                /*一页多少条*/
                pageSize: 10,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*搜索参数*/
                searchForm: {
                    goods_name: "",
                    category_id: "",
                    supplier_id:''
                },
                /*列表数据*/
                tableData: [],
                /*全部分类*/
                categoryList: [],
                merch: [],
                /*商品统计*/
                goods_count: {},
                /*二维码弹窗*/
                qrcodeDialog: false,
                qrCodeData:'',
                supplierlist:[]

            };
        },
        created() {
        },
        mounted(){
            /*获取列表*/
            this.getData();
            console.log(this.activeName);
        },
        methods: {
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.loading = true;
                self.curPage = val;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.getData();
            },

            /*切换菜单*/
            handleClick(tab, event) {
                let self = this;
                self.curPage = 1;
                self.getData();
            },

            /*获取列表*/
            getData() {
                let self = this;
                let Params = self.searchForm;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                Params.type = self.activeName;
                self.loading = true;
                GoodsApi.goodsList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.categoryList = data.data.category;
                        self.supplierlist=data.data.supplier_list;
                        self.totalDataNumber = data.data.list.total;
                        self.merch = data.data.merch;
                        self.goods_count = data.data.goods_count;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*搜索查询*/
            onSubmit() {
                this.curPage = 1;
                this.getData();
            },

            /*打开添加*/
            addClick() {
                this.$router.push("/goods/goods/add");
            },

            /*打开编辑*/
            editClick(row) {
                this.$router.push({
                    path: "/goods/goods/edit",
                    query: {
                        goods_id: row.goods_id,
                        scene: "edit"
                    }
                });
            },
            editCoupon(row) {
                this.$router.push({
                    path: "/goods/goods/coupon",
                    query: {
                        goods_id: row.goods_id,
                    }
                });
            },
            editRelation(row) {
                this.$router.push({
                    path: "/goods/goods/relation",
                    query: {
                        goods_id: row.goods_id,
                    }
                });
            },

            /*预览*/
            previewClick(row) {
                //当前域名/view_goods?goods_id=&view_token=
                GoodsApi.getToken({}, true).then((res)=>{
                    let qrCodeData = window.location.origin + '/view_goods/?goods_id=' + row.goods_id + '&view_token=' + res.data;
                    //生成一个二维码
                    this.qrcodeDialog = true;

                    QRCode.toDataURL(qrCodeData, (err, url) => {
                        if (err) {
                            console.error(err)
                        } else {
                            this.qrCodeData = url
                            console.log('previewClick',qrCodeData)
                            console.log('qrcodeData',url)
                        }
                    })


                })
            },

            /*打开复制*/
            copyClick(row) {
                this.$router.push({
                    path: "/goods/goods/edit",
                    query: {
                        goods_id: row.goods_id,
                        scene: "copy"
                    }
                });
            },

            /*删除*/
            delClick: function(row) {
                let self = this;
                let msg = "";
                if (row.goods_status == 30) {
                    msg = "删除后不可恢复，确认删除该记录吗?";
                } else {
                    msg = "删除后将移动到回收站，确定删除该记录吗?";
                }
                self.$confirm(msg, "提示", {
                    type: "warning"
                }).then(() => {
                    GoodsApi.delGoods({
                        goods_id: row.goods_id
                    }).then((data) => {
                        self.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        self.getData();
                    });
                });
            },
            /*修改状态*/
            changeStatus(item, value) {
                let self = this;
                let msg = "";
                if (value == 10) {
                    msg = "确认要上架该商品吗?";
                } else {
                    msg = "确认要下架该商品吗?";
                    if (self.activeName == "recovery") {
                        msg = "确认要移动该商品到仓库吗?";
                    }
                }
                self.$confirm(msg, "提示", {
                    type: "warning"
                }).then(() => {
                    GoodsApi.changeStatus({
                        goods_id: item.goods_id,
                        state: value
                    }).then((data) => {
                        self.$message({
                            message: "操作成功",
                            type: "success"
                        });
                        self.getData();
                    });
                });
            },
            changeSort(e,item){
                let self = this;
                GoodsApi.changeSort({
                    goods_id: item.goods_id,
                    sort: e
                }).then((data) => {
                    self.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    self.getData();
                });
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/goods/goods/index.vue